import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export const AdminPayments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/payments")
      .then((r) => setItems(r.data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="py-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-brand-red" /></div>;
  }

  return (
    <div className="rounded-3xl bg-white border border-brand-navy/10 overflow-x-auto" data-testid="admin-payments-table">
      <table className="w-full text-sm">
        <thead className="bg-brand-muted-bg text-brand-navy">
          <tr>
            {["Type", "Item", "User", "Amount", "Mode", "Status", "Date"].map((h) => (
              <th key={h} className="text-left px-5 py-4 font-semibold text-xs uppercase tracking-widest">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr><td colSpan={7} className="text-center py-10 text-brand-navy/50">No payments yet.</td></tr>
          )}
          {items.map((p) => (
            <tr key={p.order_id} data-testid={`payment-row-${p.order_id}`} className="border-t border-brand-navy/5">
              <td className="px-5 py-4"><Badge variant="outline" className="capitalize">{p.type}</Badge></td>
              <td className="px-5 py-4 font-semibold text-brand-navy">{p.item || "—"}</td>
              <td className="px-5 py-4 text-brand-navy/70">
                <div>{p.user_name || "—"}</div>
                <div className="text-xs text-brand-navy/50">{p.user_email || p.user_id}</div>
              </td>
              <td className="px-5 py-4 font-bold text-brand-navy">₹{((p.amount || 0) / 100).toLocaleString("en-IN")}</td>
              <td className="px-5 py-4"><Badge className={p.mode === "live" ? "bg-emerald-600 hover:bg-emerald-600" : "bg-brand-navy hover:bg-brand-navy"}>{p.mode}</Badge></td>
              <td className="px-5 py-4"><Badge className={p.status === "paid" ? "bg-emerald-600 hover:bg-emerald-600" : "bg-brand-gold text-brand-navy hover:bg-brand-gold"}>{p.status}</Badge></td>
              <td className="px-5 py-4 text-xs text-brand-navy/50">{p.created_at ? new Date(p.created_at).toLocaleString() : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
